import type { QueryFunction } from 'common/queryFunction';
import { useQuery } from 'react-query';

import { Address, getAccountsKey, useRequest } from '@frontend/api';

export const getBillingAddressesQueryKey = () =>
  [...getAccountsKey(), 'billingAddresses'] as const;

export const getBillingAddressesDetailsQueryKey = (
  params: UseBillingAddressParams,
) => [...getBillingAddressesQueryKey(), 'details', params] as const;

export type UseBillingAddressParams = {
  billingAddressId: string;
};

export type BillingAddressData = { id: number; address: Address };

export const useBillingAddress: QueryFunction<
  BillingAddressData,
  [UseBillingAddressParams],
  ReturnType<typeof getBillingAddressesDetailsQueryKey>
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getBillingAddressesDetailsQueryKey(params);
  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/accounts/billing_addresses/${params.billingAddressId}`, {
        init: {
          signal,
        },
      }),
  });
};
